import Route from '@ember/routing/route';

export default class CustomiseRoute extends Route {}
